<template>
<div>
  <a
    @click="handleSubmit" class="btn u-mg-t-2"
    data-block="true"
    data-color="brand"
    data-stroke="true"
  >{{ triggerLabel }}</a>
  <form action="/payment/change_payment_input" method="post" ref="form">
    <input type="hidden" name="_token" :value="csrfToken">
    <input type="hidden" name="cpno" :value="cpno">
    <input type="hidden" name="order_id" :value="orderId" />
    <input type="hidden" v-for="(value, key) in formParam" :key="key" :name="key" :value="value">
    <input type="hidden" name="token" :value="token" v-if="token">
    <input type="hidden" name="tokenKey" :value="tokenKey" v-if="tokenKey">
    <input type="hidden" name="cc_number" :value="maskedCcNumber" v-if="maskedCcNumber">
  </form>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import paymentMixins from './payment-mixins'
import { PAYEE } from '@/CONSTS'
import * as type from '@/utvStore/store/mutation-types'
let initialLocation = location.origin + location.pathname

export default {
  name: 'change-payment-type',
  mixins: [paymentMixins],
  data() {
    return {
      PAYEE,
      ga_location: initialLocation,
      isShowModal: false,
      requiredFieldsBool: false,
      showLoading: false,
      triggerLabel: '別のお支払い方法を使う'
    }
  },
  beforeMount() {
    this.getPaymentData()
  },
  computed: {
    ...mapState({
      lastPayee: state => state.payment.lastPayee
    })
  },
  props: {
    orderId: { type: String, required: true },
    formParam: Object,
    ccNumber: String,
    ccExpiration: String,
    itemName: String,
    itemPrice: [String, Number]
  },
  methods: {
    handleSubmit() {
      this.showLoading = true
      this.$refs.form.submit()
    }
  }
}
</script>

<style lang="scss">
.securityCode {
  position: relative;
  &__question {
    position: absolute;
    left: 88px;
    top: 25px;
    cursor: pointer;
  }
  &__about {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    border-radius: 4px;
    left: 120px;
    top: 0;
    align-items: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    &[data-visible='true'] {
      opacity: 1;
      pointer-events: auto;
    }
    .media__content p {
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.modal {
  &.simple {
    .actionarea {
      display: flex;
      margin: 0 -7px;

      .button {
        width: 100%;
        outline: 0;
        margin: 0 7px;
      }
    }
  }
  // payment_modal
  &.payment {
    .close {
      width: 48px;
      float: right;
    }

    .modal__content {
      border-radius: 2px;
    }

    .modal__header {
      position: absolute;
      width: 100%;
    }

    .modal__body {
      .content {
        padding: 24px 16px;

        &__inner {
          .caption {
            line-height: 16px;
            margin-bottom: 24px;
          }
          .price {
            display: flex;
          }
          .type {
            display: flex;
          }
          .flexbox {
            display: flex;
          }
          .label {
            width: 100%;
          }
          .value {
            width: 100%;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/ChangePaymentType.vue